"use client";

import { UserPerceivedLoadTimingContext } from "@faire/web/common/performance/userPerceivedLoadTiming/UserPerceivedLoadTimingContext";
import React, { use, useContext } from "react";

export const DeferNonPrimaryContentWrapper: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  useNonPrimaryContentDeferRender();
  return <>{children}</>;
};

// Defer rendering until critical components are loaded
const useNonPrimaryContentDeferRender = () => {
  const { renderNonPrimaryContentPromise } = useContext(
    UserPerceivedLoadTimingContext
  );
  // use will wait for the promise to resolve before rendering the component
  // and render suspense fallback if the promise is not resolved yet
  use(renderNonPrimaryContentPromise);
};
